<template>
  <div class="lead-detailed-statistics">
    <div class="page-header">
      <div class="title-grid">
        <h4>{{$t('statistics.lead_statistics')}}</h4>
        <relative-date-choser :choices="[1,7,30,60]" @change="newDate"></relative-date-choser>
      </div>
      <router-link :to="{ name: 'project_lead_edit', params: {id: id, leadId: this.lead_id} }">
        <i class="icon yule-icon-chevron-left"></i> {{$t('statistics.get_back_to_lead')}}
      </router-link>
    </div>
    <div v-if="trackings.length > 0">
      <tracking-chart :start-date="start_date.format()" :end-date="end_date.format()" :trackings="trackings" />
      <br><br>
      <div v-for="trackings in trackingsSorted" :key="trackings[0].time" class="tracking-table">
        <div class="tracking-table--date">
          {{ moment(trackings[0].time).format('MMMM Do') }}
        </div>
        <tracking-table :project-id="id" :trackings="trackings" />
      </div>
    </div>
    <div v-else>
      {{$t('statistics.no_data')}}
    </div>

  </div>
</template>
<script>
import moment from 'moment'
import Tracking from "@/api/Tracking"
import TrackingTable from "./TrackingTable"
import TrackingChart from "@/components/helpers/Specific/TrackingChart"
import RelativeDateChoser from "@/components/helpers/DataInput/RelativeDateChoser"
import Ui from "@/classes/Ui"
import Api from '@/api/Lead.js'
import ProjectApi from '@/api/Project.js'

export default {
  props: ['id'],
  components: { TrackingTable, TrackingChart, RelativeDateChoser },
  data(){
    return {
      trackings: [],
      tracking_api: new Tracking(),
      start_date: Object,
      end_date: Object,
      trackingsSorted: [],
      moment,
      api: new Api(),
    }
  },
  mounted(){
    this.newDate(1)
    this.validateLeadPresent()
    this.validateProjectPresent()
  },
  computed: {
    lead_id() {
      return this.$route.params.lead_id
    }
  },
  methods: {
    validateLeadPresent() {
      if (typeof this.$store.state.page_title == 'undefined' || this.$store.state.page_title == '' ){
        // re-set level when statistics are reached outside edit (then, level was 2)
        Ui.setPageLevel(3)
        this.retrieve_lead()
      }
    },
    validateProjectPresent() {
      if (typeof this.$store.state.parent_page_title.name == 'undefined' || this.$store.state.parent_page_title.name == ''){
        this.retrieve_project()
      }
    },
    // lead retriving
    retrieve_lead() {
      this.api['show'](this.lead_id).then((item) => {
        Ui.setTitleName(item)
      }).catch(function(error) {
        console.log(error)
      })
    },
    retrieve_project(){
      let project_api = new ProjectApi()
      project_api.show(this.id).then((item) => {
        Ui.setSubtitle({link: {name: "project_show", params: {id: item.id}}, name: item.name})
      }).catch((error) => {
        console.log(error)
      })
    },
    newDate(date){
      this.start_date = moment().subtract(date, 'days')
      this.end_date = moment()
      this.trackings = []
      this.trackingsSorted = []
      console.log("init")
      this.retrieve()
    },
    retrieve(){
      let params = {
        start_date: this.start_date,
        end_date: this.end_date,
        sort_by: 'time',
        sort_order: 'DESC'
      }
      this.tracking_api.all(Object.assign({lead_id: this.lead_id},params)).then((items) => {
        this.trackings = items.resources
        this.initTrackings()
      }).catch((error) => {
      })
    },
    initTrackings(){
      // sort trackings
      this.trackings.sort(function(a,b){
        let dateA = new Date(a.time)
        let dateB = new Date(b.time)
        if (dateA < dateB) return 1;
        else if(dateA > dateB) return -1;
        else return  0;
      });

      let currentTrackings = []
      this.trackingsSorted = []

      this.trackings.forEach((tracking, index) => {
        if(index == 0){
          currentTrackings.push(tracking)
          return
        }
        let currentDate = new Date(tracking.time)
        let lastDate = new Date(this.trackings[index-1].time)

        if(this.sameDay(currentDate, lastDate)){
          currentTrackings.push(tracking)
        }else{
          this.trackingsSorted.push(currentTrackings)
          currentTrackings = [tracking]
        }
      })
      this.trackingsSorted.push(currentTrackings)
    },
    sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
    }
  }
}
</script>
<style lang="scss">
.secondary-header--title .organization{
  font-size: 14px;
  display: block;
}
h3{
  margin-bottom: 15px;
}
.lead-detailed-statistics{
  a{
    color: #2e7bae;
  }
  h3{
    margin-bottom: 0px;
  }

  h4 {
    font-weight: 400;
    margin: .6em 0;
    color: $onyx;
  }
  .page-header{
    margin-bottom: 20px;
    a{
      text-align: right;
      text-decoration: none;
    }
    .icon{
      font-size: 14px;
      vertical-align: sub;
    }
  }
  .title-grid{
    align-items: center;
    margin-bottom: 10px;
  }
}

.tracking-table--date{
  color: #a09898;
  font-size: 14px;
  margin-bottom: 10px;
}

@media(max-width: 575px) {
  .title-grid{
    align-items: flex-start;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }
  .relative-date-choser {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// LeadDetailedStatistics.vue?204fdadc